import { Policy } from '@lockton-apps/shared/interfaces';

export const PolicyCobMap = {
  LSOS: 466,
} as const;

export function isLsosPolicy<P extends Policy>(policy: P): boolean {
  return policy.classOfBusinessId === PolicyCobMap.LSOS;
}
